import SelectedPOI from './SelectedPOI';

export default SelectedPOI;
